module.exports = __webpack_public_path__ + "img/scaldris_ice_floes.a8916429.png";